"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createMetaReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _actionHelpers = require("./actionHelpers");

var _asyncHelpers = require("./asyncHelpers");

var _ramda = require("ramda");

var defaultState = {
  pending: false,
  error: false,
  success: false,
  lastSucceedAt: null
};

function createMetaReducer(actionName) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _defineProperty2["default"])({}, _asyncHelpers.defaultKey, defaultState);

    var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
        type = _ref2.type,
        payload = _ref2.payload,
        params = _ref2.params,
        _ref2$attrs = _ref2.attrs,
        attrs = _ref2$attrs === void 0 ? {} : _ref2$attrs,
        requestAction = _ref2.requestAction;

    var param = (0, _ramda.pathOr)(params || _asyncHelpers.noParamsKey, ['params'], requestAction);

    var getLastSucceedAt = function getLastSucceedAt() {
      return (0, _ramda.pathOr)(null, [(0, _asyncHelpers.getPath)(param), 'lastSucceedAt'], state);
    };

    var getMeta = function getMeta(pending, error, success) {
      var lastSucceedAt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : getLastSucceedAt();
      return {
        pending: pending,
        error: error,
        success: success,
        lastSucceedAt: lastSucceedAt
      };
    };

    var getState = function getState(meta) {
      return (0, _ramda.assoc)((0, _asyncHelpers.getPath)(param), meta, state);
    };

    switch (type) {
      case (0, _actionHelpers.toRequest)(actionName):
        return getState(getMeta(true, false, false));

      case (0, _actionHelpers.toSuccess)(actionName):
        var error = attrs.error,
            lastSucceedAt = attrs.lastSucceedAt;
        return getState(getMeta(false, error || false, true, lastSucceedAt));

      case (0, _actionHelpers.toError)(actionName):
        return getState(getMeta(false, payload, false));

      case (0, _actionHelpers.toReset)(actionName):
        return getState(defaultState);

      case (0, _actionHelpers.toLoad)(actionName):
        var updateState = (0, _ramda.assocPath)([(0, _asyncHelpers.getPath)(param), 'lastSucceedAt'], attrs.lastSucceedAt);
        return !getLastSucceedAt() || attrs.force ? updateState(state) : state;

      default:
        return state;
    }
  };
}